import type { SVGProps } from 'react'
const SvgIdea = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M10 .833V2.5M3.517 3.517 4.7 4.7M.833 10H2.5M17.5 10h1.667M15.3 4.7l1.184-1.183"
    />
    <path
      fill="currentColor"
      d="m12 13.657-.312-.57a.65.65 0 0 0-.338.57zm-4-.001h.65a.65.65 0 0 0-.337-.57zm4.312.57A4.82 4.82 0 0 0 14.817 10h-1.3c0 1.33-.738 2.488-1.83 3.086zM14.817 10a4.817 4.817 0 0 0-4.816-4.817v1.3A3.517 3.517 0 0 1 13.517 10zm-4.816-4.817A4.817 4.817 0 0 0 5.184 10h1.3a3.517 3.517 0 0 1 3.517-3.517zM5.184 10a4.82 4.82 0 0 0 2.503 4.226l.626-1.14A3.52 3.52 0 0 1 6.484 10zm3.466 7.167v-3.511h-1.3v3.51zm1.35 1.35a1.35 1.35 0 0 1-1.35-1.35h-1.3a2.65 2.65 0 0 0 2.65 2.65zm1.35-1.35a1.35 1.35 0 0 1-1.35 1.35v1.3a2.65 2.65 0 0 0 2.65-2.65zm0-3.51v3.51h1.3v-3.51z"
    />
  </svg>
)
export default SvgIdea
